import React from 'react';
import UsuarioApi from '../api/UsuarioApi';
import { getName, getToken, getRoles, getUsername } from '../util/keycloak';

const ALL_ROLES = [
  { id: 'administrador_plano', descricao: 'Administrador Plano' },
  { id: 'gestor', descricao: 'Gestor' },
  { id: 'auditor_med_autorizacao', descricao: 'Auditor Médico Autorização' },
  { id: 'auditor_med_faturamento', descricao: 'Auditor Médico Faturamento' },
  { id: 'auditor_med_auxiliar', descricao: 'Auditor Médico Auxiliar' },
  { id: 'auditor_med_externo', descricao: 'Auditor Médico Externo' },
  { id: 'gestor_autorizacao', descricao: 'Gestor Autorização' },
  { id: 'gestor_fatura', descricao: 'Gestor Fatura' },
  { id: 'perito_odontologico', descricao: 'Perito Odontólogico' },
  { id: 'gestor_fatura_odonto', descricao: 'Gestor Fatura Odonto' },
  { id: 'gestor_autorizacao_odonto', descricao: 'Gestor Autorização Odonto' },
  { id: 'prestador', descricao: 'Prestador' },
  { id: 'prestador_faturamento', descricao: 'Prestador Faturamento' },
  { id: 'prestador_autorizacao', descricao: 'Prestador Autorização' },
  { id: 'prestador_medico', descricao: 'Prestador Médico' },
  { id: 'prestador_odontologico', descricao: 'Prestador Odontólogico' },
  { id: 'prestador_medico_autorizacao', descricao: 'Prestador Médico Autorização' },
  { id: 'prestador_odontologico_autorizacao', descricao: 'Prestador Odontólogico Autorização' },
  { id: 'prestador_medico_faturamento', descricao: 'Prestador Médico Faturamento' },
  { id: 'prestador_odontologico_faturamento', descricao: 'Prestador Odontólogico Faturamento' },
  { id: 'usuario_consulta', descricao: 'Usuário Consulta' },
  { id: 'reembolso_consulta', descricao: 'Reembolso Consulta' },
];

const SERVIDORES_CAUPE = ['C049870', 'C033182', 'C037940', 'C041415', 'C040820', 'C060420', 'C031277', 'C031150', 'C033075', 'C057139', 'C046476', 'C048514'];
const SERVIDORES_APENAS_CONSULTA = ['C034869', 'E008688'];
const CNPJ_UNIMED = '02812468000106';

const UsuarioContext = React.createContext({});

class UsuarioProvider extends React.Component {
  usuarioApi = new UsuarioApi();
  constructor () {
    super();
    this.state = {
      usuarioAplicacao: undefined,
      previousPath: '/dashboard'
    }
  }

  saveLocationOnError = (path) => {
    this.setState({ previousPath: path !== undefined ? path : this.state.previousPath })
  }

  fetchUsuarioAplicacao = async () => {
    let usuarioAplicacao = await this.usuarioApi.recuperarUsuarioAplicacao(getUsername());
    this.setState({ usuarioAplicacao: usuarioAplicacao })
  }

  isUsuarioLogado = async () => {
    let isLogado = getToken() !== undefined;
    if (isLogado && this.state.usuarioAplicacao === undefined) {
      await this.fetchUsuarioAplicacao();
    }
    return isLogado;
  }

  codigoUsuario () {
    return getUsername();
  }

  nomeUsuario () {
    return getName();
  }

  roles () {
    return ALL_ROLES.filter(r => getRoles().includes(r.id)).map(role => role.descricao);
  }

  isEmAlgumaRole () {
    return getRoles().some(role => ALL_ROLES.map(r => r.id).indexOf(role) > -1);
  }

  isUnimed () {
    if (this.isPrestador() && this.state.usuarioAplicacao !== undefined) {
      return this.state.usuarioAplicacao.usuarioPrestador.cpfCnpj === CNPJ_UNIMED;
    }
    return  false;
  }

  isGestor () {
    const GESTOR = "gestor";
    return getRoles().some(role => ALL_ROLES.filter(obj => obj.id.includes(GESTOR)).map(r => r.id).indexOf(role) > -1);
  }

  isPrestador () {
    const PRESTADOR = "prestador";
    return getRoles().some(role => ALL_ROLES.filter(obj => obj.id.includes(PRESTADOR)).map(r => r.id).indexOf(role) > -1);
  }

  isCAUPE () {
    return SERVIDORES_CAUPE.includes(getUsername());
  }

  isApenasConsulta () {
    return SERVIDORES_APENAS_CONSULTA.includes(getUsername());
  }

  getCodPrestador () {
    if (this.isPrestador() && this.state.usuarioAplicacao !== undefined) {
      return this.state. usuarioAplicacao.usuarioPrestador.codPrestador;
    }
    return undefined;
  }

  getNomPrestador () {
    if (this.isPrestador() && this.state.usuarioAplicacao !== undefined) {
      return this.state. usuarioAplicacao.usuarioPrestador.nomPrestador;
    }
    return undefined;
  }

  getCpfCnpj () {
    if (this.isPrestador() && this.state.usuarioAplicacao !== undefined) {
      return this.state. usuarioAplicacao.usuarioPrestador.cpfCnpj;
    }
    return undefined;
  }

  render () {
    return (
      <UsuarioContext.Provider
        value={{
          saveLocationOnError: this.saveLocationOnError,
          fetchUsuarioAplicacao: this.fetchUsuarioAplicacao,
          usuarioAplicacao: this.state.usuarioAplicacao,
          previousPath: this.state.previousPath,
          isPrestador: this.isPrestador(),
          isUsuarioLogado: this.isUsuarioLogado(),
          codigoUsuario: this.codigoUsuario(),
          nomeUsuario: this.nomeUsuario(),
          roles: this.roles(),
          isEmAlgumaRole: this.isEmAlgumaRole(),
          isUnimed: this.isUnimed(),
          isGestor: this.isGestor(),
          isCAUPE: this.isCAUPE(),
          isApenasConsulta: this.isApenasConsulta(),
          codPrestador: this.getCodPrestador(),
          nomPrestador: this.getNomPrestador(),
          cpfCnpj: this.getCpfCnpj(),
        }}
      >
        {this.props.children}
      </UsuarioContext.Provider>
    );
  }
}

const UsuarioConsumer = UsuarioContext.Consumer;

function withUsuario (Component) {
  return function ComponentWithUsuarioContext (props) {
    return (
      <UsuarioConsumer>
        {context => <Component {...context} {...props} />}
      </UsuarioConsumer>
    );
  };
}

export { UsuarioProvider, withUsuario };
